<template>
  <main>
    <md-card>
      <md-card-header>
        <div class="md-title">お知らせ</div>
      </md-card-header>

      <loading-spinner v-if="loadList"></loading-spinner>
      <md-card-content v-else-if="errorMessages.length">
        <div class="md-layout">
          <div class="md-layout-item md-size-100">
            <flash-message :errors="errorMessages"></flash-message>
          </div>
        </div>
      </md-card-content>
      <flash-message v-else-if="errorDeleteMessages.length" :errors="errorDeleteMessages"></flash-message>
      <md-card-content v-if="!loadList">
        <md-table v-if="pagination.total !== null">
          <md-table-row>
            <md-table-head v-for="(column, key) in columns" v-bind:key="'column-key-' + key">
              <a href="#" @click="sortBy(informations, key)"
                 v-bind:class="{'active' : sortKey === key}">{{column.name}}</a>
              <md-icon v-if="sortKey === key && statusSort === 'desc'">arrow_downward</md-icon>
              <md-icon v-else-if="sortKey === key && statusSort === 'asc'">arrow_upward</md-icon>
            </md-table-head>
            <md-table-head>
              <router-link :to="{name: 'BackendAdminNotificationNew'}">
                <md-button :disabled="sending" class="md-primary md-raised">
                  <md-icon>add</md-icon>
                  <span>新規登録</span>
                </md-button>
              </router-link>
            </md-table-head>
          </md-table-row>
          <md-table-row v-if="informations.length === 0">
            <md-table-cell colspan="3">{{emptyResponseMessage}}</md-table-cell>
          </md-table-row>
          <md-table-row v-else v-for="(information, key) in informations" v-bind:key="'information-key-' + key">
            <md-table-cell>{{information.information_date}}</md-table-cell>
            <md-table-cell>{{information.subject}}</md-table-cell>
            <md-table-cell>{{datetimeFormat(information.publication_date_begin, 'YYYY-MM-DD HH:mm')}} 〜 {{datetimeFormat(information.publication_date_end, 'YYYY-MM-DD HH:mm')}}</md-table-cell>
            <md-table-cell>
              <div class="flexbox">
                <div>
                  <router-link
                      :to="{name: 'BackendAdminNotificationNew', params: {id: information.information_id.toString()}}">
                    <md-button :disabled="sending" class="md-raised">
                      <md-icon>edit</md-icon>
                      編集
                    </md-button>
                  </router-link>
                </div>
                <div>
                  <md-button :disabled="sending" class="md-accent md-raised"
                             @click="openPopUpConfirm(information.information_id)">
                    <md-icon>delete</md-icon>
                    削除
                  </md-button>
                </div>
              </div>
            </md-table-cell>
          </md-table-row>
        </md-table>

        <pagination v-if="pagination.total"
                    :total="pagination.total"
                    :per-page="pagination.per_page"
                    :current-page="pagination.current_page"
                    @pagechanged="onPageChanged"
        />
        <delete-modal
          :md-active.sync="showDeleteModal"
          :md-title="popupConfirm.title"
          :md-content="popupConfirm.content"
          confirm-button-class="md-accent md-raised"
          cancel-button-class="md-raised"
          @md-cancel="onDeleteCancel"
          @md-confirm="deleteInformationSubmit"/>
        <md-snackbar :md-active.sync="showSnackBar"
                     :md-duration="snackbarDuration"
                     @md-closed="showSnackBar = false">
          <span>{{ successMessage }}</span>
          <md-button class="md-primary" @click="showSnackBar = false">閉じる</md-button>
        </md-snackbar>
      </md-card-content>
    </md-card>
  </main>
</template>

<script>
import FlashMessage                                      from '../../../components/FlashMessage';
import Pagination                                        from '../../../components/Pagination';
import Common                                            from '../../../modules/common';
import CommonMixin                                       from '../../../mixins/commonMixin';
import DeleteModal                                       from '../../../components/DeleteModal';
import {apiClientWithManagerToken as apiClient, apiList} from '../../../modules/apiClient';
import LoadingSpinner                                    from '../../../components/LoadingSpinner';
import {mapActions, mapGetters,}                         from 'vuex';

export default {
    name      : "AdminNotifications",
    mixins    : [CommonMixin],
    components: {
      LoadingSpinner,
      Pagination,
      FlashMessage,
      DeleteModal,
    },
    data      : () => ({
      sending             : false,
      informations        : [],
      errorMessages       : [],
      emptyResponseMessage: Common.messages.errorGet,
      errorDeleteMessages : [],
      popupConfirm        : {
        title        : Common.messages.informationList.confirmTitle,
        content      : Common.messages.informationList.confirmContent,
        informationId: null
      },
      // Sort config
      sortKey             : 'publication_date_begin',
      statusSort          : 'desc',
      columns             : {
        information_date      : {name: 'お知らせ日', sort: 'asc'},
        subject               : {name: '件名', sort: 'asc'},
        publication_date_begin: {name: '掲載期間', sort: 'desc'},
      },
      // Pagination
      pagination          : {
        total       : null,
        per_page    : Common.limitPageDefault,
        current_page: 1,
      },
      loadList            : false,
    }),
    mounted   : function () {
      this.applyState();
      this.getInformation();
      this.getSnackBar();
    },
    computed  : {
      ...mapGetters('adminNotifications', {
        formData : 'formData',
        sortData : 'sortData',
        isRefresh: 'isRefresh',
        isBack   : 'isBack',
      }),
    },
    methods   : {
      ...mapActions('adminNotifications', [
        'saveFormData',
        'saveSortData',
        'saveRefresh',
        'saveBack',
      ]),
      applyState() {
        if (this.isRefresh || this.isBack) {
          if (this.formData !== null) {
            this.pagination.current_page = this.formData.page;
            this.pagination.per_page     = this.formData.limit;
          }
          if (this.sortData !== null) {
            this.sortKey    = this.sortData.sortKey;
            this.statusSort = this.sortData.statusSort;
          }
        }
        this.saveRefresh(false);
        this.saveBack(false);
      },
      setMetaPagination(meta) {
        this.pagination.total        = meta.total;
        this.pagination.per_page     = meta.per_page;
        this.pagination.current_page = meta.current_page;
      },
      clearData() {
        this.errorDeleteMessages = [];
        this.successMessage      = null;
      },
      getInformation() {
        this.saveFormData({
          page : this.pagination.current_page,
          limit: this.pagination.per_page,
        });
        this.saveSortData({
          sortKey   : this.sortKey,
          statusSort: this.statusSort,
        });
        this.clearData();
        this.sending  = true;
        this.loadList = true;
        apiClient.get(apiList.information.information, {
          params: {
            page : this.pagination.current_page,
            limit: this.pagination.per_page,
          }
        })
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            const result = response.data;
            this.setMetaPagination(result.meta);
            this.informations = result.informations;
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.sortBy(this.informations);
            this.sending  = false
            this.loadList = false;
          });
      },
      deleteInformation() {
        this.sending = true;
        apiClient.delete(apiList.information.delete.replace(':information_id', this.popupConfirm.informationId))
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            if (Math.ceil((this.pagination.total - 1) / this.pagination.per_page) < this.pagination.current_page) {
              this.pagination.current_page = (this.pagination.current_page - 1) || 1;
            }
            this.getInformation();
            this.successMessage = Common.messages.informationList.successDeleteMsg;
            this.showSnackBar   = true;
          })
          .catch(error => {
            this.errorDeleteMessages = [error.message];
          })
          .finally(() => {
            this.sending                    = false;
            this.popupConfirm.informationId = null;
          });
      },
      onPageChanged(page) {
        this.pagination.current_page = page;
        this.getInformation();
      },
      openPopUpConfirm(informationId) {
        this.showDeleteModal            = true;
        this.popupConfirm.informationId = informationId;
      },
      onDeleteCancel() {
        this.showDeleteModal            = false;
        this.popupConfirm.informationId = null;
      },
      deleteInformationSubmit() {
        this.showDeleteModal = false;
        this.deleteInformation();
      },
    }
  }
</script>

<style lang="scss" scoped>
  .md-theme-default a:not(.md-button) {
    color: black;
  }

  a.active {
    font-weight: bold;
    color: black;
  }

  .md-table-cell {
    min-width: 150px;
  }
</style>
